
export default class PostContainerWidth{

    constructor(){

        window.addEventListener('resize', () => {
            this.setUnit();
        });

        this.setUnit();
    }

    setUnit(){
        let pc = jQuery( '.post-container' ).width();
        document.documentElement.style.setProperty('--who--js--post-container--width', `${pc}px`);
    }


}